/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, duration: NonNullable<unknown> }} Ui_Laps_Efforts_PatternInputs */

const en_ui_laps_efforts_pattern = /** @type {(inputs: Ui_Laps_Efforts_PatternInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} × ${i?.duration}`)
};

const de_ui_laps_efforts_pattern = /** @type {(inputs: Ui_Laps_Efforts_PatternInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} × ${i?.duration}`)
};

/**
* | output |
* | --- |
* | "{count} × {duration}" |
*
* @param {Ui_Laps_Efforts_PatternInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts_pattern = /** @type {((inputs: Ui_Laps_Efforts_PatternInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Efforts_PatternInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts_pattern(inputs)
	return de_ui_laps_efforts_pattern(inputs)
});